export { default as TextInput } from './textinput'
export type { Props as TextInputProps } from './textinput'
